<template>
  <div id="Error">
        <div class="info">
            <strong>서비스에 접속할 수 없습니다.</strong>
            <p>
                기술적인 문제로 일시적으로 접속되지 않았습니다.<br/>
                이용에 불편을 드려서 죄송합니다.
            </p>
        </div>
        
        <div class="btnWrap">
            <button type="button" class="red" @click="moveMain">메인 이동</button>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    moveMain() {
      this.$router.push({ name: "main" }).catch(function() {});
    },
  },
};
</script>